import { ZendeskHelpCenterUrlList } from './ZendeskHelpCenterUrlList';
import type { Control, UseFormClearErrors } from 'react-hook-form';
import type { ZendeskHelpCenterFormValues } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/create/CreateZendeskIntegrationPopup/ZendeskIntegrationForm2/zendeskHelpCenterFormValues';

export const ZendeskHelpCenterAddUrls = ({
  control,
  clearErrors = () => {},
}: {
  control: Control<ZendeskHelpCenterFormValues>;
  clearErrors?: UseFormClearErrors<ZendeskHelpCenterFormValues>;
}) => (
  <ZendeskHelpCenterUrlList
    control={control}
    clearErrors={clearErrors}
    name={'source_links'}
    title={'Added URLs'}
    itemLabel={'added URL'}
    addLabel={'Add specific articles'}
  />
);
